import { Link } from "react-router-dom";
import { ArrowUpRight, Instagram } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { SafeImage } from "@/components/SafeImage";
import { INSTAGRAM_URL } from "@/lib/site";

const PREVIEW = [
  { src: "/assets/post-08.png", title: "Antes / Depois" },
  { src: "/assets/post-01.png", title: "O que é Rope Access?" },
  { src: "/assets/post-11.png", title: "Orçamento gratuito" },
];

export const PackTeaser = () => (
  <section data-testid="pack-teaser-section" className="mx-auto max-w-7xl px-6 py-24 md:py-32">
    <Reveal>
      <p className="mb-4 font-mono text-xs uppercase tracking-[0.3em] text-krono">[ Instagram ]</p>
      <h2 className="max-w-2xl font-display text-3xl font-bold tracking-tight sm:text-4xl lg:text-5xl">
        O feed que faz síndico parar o scroll.
      </h2>
    </Reveal>
    <div className="mt-16 grid gap-6 sm:grid-cols-3">
      {PREVIEW.map((p, i) => (
        <Reveal key={p.src} delay={i * 0.1}>
          <div className="group overflow-hidden border border-white/10" data-testid={`pack-preview-${i + 1}`}>
            <SafeImage
              src={p.src}
              alt={`Arte de post KRONO — ${p.title}`}
              label={p.title}
              className="aspect-[4/5] w-full object-cover transition-transform duration-700 group-hover:scale-105"
            />
          </div>
        </Reveal>
      ))}
    </div>
    <Reveal delay={0.2} className="mt-10 flex flex-col gap-4 sm:flex-row">
      <Link
        to="/conteudo"
        data-testid="pack-cta-full"
        className="group inline-flex items-center gap-3 border border-krono px-8 py-4 font-mono text-sm font-bold uppercase tracking-[0.15em] text-krono transition-colors hover:bg-krono hover:text-black"
      >
        Ver pacote de conteúdo do mês
        <ArrowUpRight className="h-4 w-4 transition-transform group-hover:-translate-y-1 group-hover:translate-x-1" />
      </Link>
      <a
        href={INSTAGRAM_URL}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="pack-cta-instagram"
        className="inline-flex items-center gap-3 border border-white/20 px-8 py-4 font-mono text-sm uppercase tracking-[0.15em] text-white/80 transition-colors hover:border-krono hover:text-krono"
      >
        <Instagram className="h-4 w-4" />
        Seguir @krono.paint
      </a>
    </Reveal>
  </section>
);
